import * as Yup from 'yup';
import { getSelectSchema } from 'src/compass/shared/schemas';
import { Terms } from 'src/compass/shared/util/terms';

export const AccountSchema = Yup.object().shape({
  entityObj: getSelectSchema(Terms.Customer.label),
  crmDealObj: getSelectSchema(Terms.CRM.label),
});
